
import Vue from 'vue'
import { mapActions } from 'vuex'
import eventBus from '@/common/utils/eventBus'
import { ENDPOINTS } from '@/product/const'
import { APP_EVENTS, SYSTEM_ERROR } from '@/common/constants'
import axios from '@/common/utils/axios_utils'
import { captureMessage } from '@sentry/browser'
import IconHeartTop from '@/common/components/icons/IconHeartTop.vue'
import IconHeartBottom from '@/common/components/icons/IconHeartBottom.vue'
import LocalStorageSerializer from '@/common/localStorageSerializer'
import { LOCAL_STORAGE_FAVORITE_PRODUCTS } from '@/editor/config/tutorial'

const MOBILE_BREAKPOINT = 768

export default Vue.extend({
  components: {
    IconHeartTop,
    IconHeartBottom
  },
  props: {
    productId: {
      type: Number,
      required: false,
      default: 0
    },
    estimateId: {
      type: String,
      required: false,
      default: ''
    },
    isList: {
      type: Boolean,
      required: false,
      default: false
    },
    isSaveLocalStorage: {
      type: Boolean,
      required: false,
      default: false
    },
    isShowTopRecommended: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data(): {
    isFavProcessing: boolean
    currentEstimateId: string
    currentProductId: string
    isNoAnimation: boolean
    isDetail: boolean
  } {
  return {
      isFavProcessing: false,
      currentEstimateId: this.estimateId,
      currentProductId: this.productId.toString(),
      isNoAnimation: true,
      isDetail: false
    }
  },
  computed: {
    product() {
      return this.$store ? this.$store.getters.product : null
    },
    isMobileView() {
      return window.innerWidth <= MOBILE_BREAKPOINT
    },
    isProductDetail() {
      return this?.$route?.path.includes('products') && this?.$route?.params?.id
    }
  },
  watch: {
    'product': function(newVal) {
      if (!this.isList) {
        this.isDetail = true
        if (newVal?.added_to_estimate) {
          this.currentEstimateId = 'show'
          this.$store.commit('setAddToEstimate', true)
        }
      }
    }
  },
  mounted() {
    eventBus.$on(APP_EVENTS.UPDATE_FAVORITES_STATUS, (estimateId: string, productId: string) => {
      if (productId === this.currentProductId) {
        if (this.currentEstimateId) {
          this.currentEstimateId = ''
        } else {
          this.currentEstimateId = estimateId
        }
      }
    })
  },
  methods: {
    ...mapActions([
      'addToEstimate',
      'removeFromEstimate'
    ]),
    async handleClickOnList() {
      if (this.isFavProcessing) return
      this.isFavProcessing = true
      try {
        let response
        if (!this.currentEstimateId) {
          response = await axios.post(ENDPOINTS.ESTIMATE_ITEMS, {
            product_id: this.currentProductId
          })
          this.showTopRecommended()
        } else {
          const url = ENDPOINTS.ESTIMATE_ITEM.replace(/%s/, this.currentEstimateId.toString())
          response = await axios.delete(url)
        }

        eventBus.$emit(APP_EVENTS.UPDATE_FAVORITES_STATUS, response.data.id || '', this.currentProductId)
        eventBus.$emit(APP_EVENTS.UPDATE_FAVORITES_COUNT_BADGE, response.data.estimate_items_count)

        if (this.isSaveLocalStorage) {
          this.toggleFavoriteOnLocalStorage(this.currentProductId, this.currentEstimateId)
        }
      } catch (error) {
        captureMessage(SYSTEM_ERROR.UNKNOWN)
      }
      this.isFavProcessing = false
    },
    onClickFavoriteButton() {
      this.isNoAnimation = false
      if (this.isDetail) {
        this.handleClickOnDetail()
      } else {
        this.handleClickOnList()
      }
    },
    toggleFavoriteOnLocalStorage(productId: string, estimateId: string ) {
      let storageItemArray = LocalStorageSerializer.get(LOCAL_STORAGE_FAVORITE_PRODUCTS)
      const item = {
        productId,
        estimateId
      }
      if (!storageItemArray) {
        storageItemArray = [item]
      } else {
        let filteredArray = storageItemArray.filter((item: { productId: string, id: string }) => item.productId !== productId)
        filteredArray.push(item)
        storageItemArray = filteredArray
      }
      LocalStorageSerializer.set(LOCAL_STORAGE_FAVORITE_PRODUCTS, storageItemArray)
    },
    async onAddToFavorite() {
      await this.addToEstimate({
        quantity: this.$store.getters.quantities.quantity,
        trial: this.$store.getters.estimate.trial,
        printable_sku_id: this.$store.getters.estimate.printable_sku_id,
        sku_printable_special_color_ids: this.$store.getters.product
          .sku_printable_special_colors,
        sku_printable_cmyk_color_ids: this.$store.getters.product.sku_printable_cmyk_colors
      })
      this.currentEstimateId = 'show'
      eventBus.$emit(APP_EVENTS.UPDATE_FAVORITES_COUNT_BADGE, this.$store.getters.favoritesCount)
      this.showTopRecommended()
    },
    async handleClickOnDetail() {
      if (this.$store.getters.addedToEstimate) {
        await this.onRemoveFromFavorite()
      } else {
        await this.onAddToFavorite()
      }
    },
    async onRemoveFromFavorite() {
      await this.removeFromEstimate(this.$store.getters.product.estimate_item_id)
      this.currentEstimateId = ''
      eventBus.$emit(APP_EVENTS.UPDATE_FAVORITES_COUNT_BADGE, this.$store.getters.favoritesCount)
    },
    showTopRecommended() {
      if (this.isProductDetail && this.isShowTopRecommended && !this.isMobileView) {
        eventBus.$emit(APP_EVENTS.SHOW_PRODUCT_RECOMANDATION, this.currentProductId)
      }
    }
  }
})
